<script setup lang="ts">


import type {RouterTab} from "@/types/tabs";
import RouterTabs from "@/components/_common/RouterTabs.vue";

const items: RouterTab[] = [
  {routeName: 'DeviceListView', title: 'All Trackers'},
  {routeName: 'GroupListView', title: 'Groups'},
]
</script>

<template>
  <RouterTabs :items="items" />
</template>
